import React from 'react'
import BomProcessAddRow from './BomProcessAddRow'
import FormDialog from '../../../../library/form/components/FormDialog';
import FormTitle from '../../../../library/form/components/FormTitle';
import FormROValue from '../../../../library/form/components/FormROValue1';
import FormInput from '../../../../library/form/components/FormInput';
import FormLabel from '../../../../library/form/components/FormLabel';
import FormLink from '../../../../library/form/components/FormLink';
import withView from '../../../cmn/docAutomation/withView';
import FormButton from '../../../../library/form/components/FormActionButton2';
import SarasTrans from '../../../../library/notifications/SarasTrans';
import FormWrapper from '../../../../library/form/components/FormWrapper';
import { UiView, UiViewHeading, UiTitle, UiAction, UiViewContent, UiRow, UiClear } from "../../../../library/layout/Index";

const BomProcessAdd = (props) => {
    const { formObject, viewData, ...restProps } = props;

    return (
        <>
            <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true} formObject={formObject}
                action={{ actionParam:{actionType: 'confirmAction'},formActions: { forAction: "Confirm", forCancel: "Cancel" } }} contentStyle={{ height: '350px' }}
                formStyle={{ width: '780px', height: '450px' }} formTitle={<FormTitle formObject={formObject} value="Add BOM Process" />}
            >
            <UiView>
                <FormWrapper formObject={formObject} headerKey="bomHeaderRow" action={{ paramName: "itemBOMContainer" }}>
                    <UiRow>
                        <span className="uiLblS uiSpacerH5">
                            <FormLabel formObject={formObject} headerKey="bomHeaderRow" action={{ paramName: "itemId" }} value="Item ID" />
                        </span>
                        <FormLink className="uiLink uiSpacerH15" formObject={formObject} headerKey="bomHeaderRow" linkProp={{ target: "_blank" }}
                            action={{ paramName: "itemId", actionId: "show", actionName: "itemComp" }}

                        />
                    </UiRow>
                    <UiRow>
                        <span className="uiLblS uiSpacerH5">
                            <FormLabel formObject={formObject} headerKey="bomHeaderRow" action={{ paramName: "itemName" }} value="Item Name" />
                        </span>
                        <FormROValue className="uiSpacerH15" formObject={formObject} headerKey="bomHeaderRow" 
                        action={{ paramName: "itemName" }} />
                    </UiRow>
                    <div className="uiSpacer10"></div>
                    <UiRow>
                        <span className="uiLblS uiSpacerH5">
                                <SarasTrans value = "Select BOM"/>
                        </span>
                        <FormInput formObject={formObject} headerKey="bomHeaderRow" className="uiInput uiVal" style={{width:'100px'}}
                            action={{ InputType: "ac", paramName: "itemCategory", acMethod: "CategoryDetail", 
                            acDepCtrl: { dparam: '%dataList.valLCat' } }}
                        />
                        <FormInput formObject={formObject} headerKey="bomHeaderRow" className="uiInput uiVal" style={{width:'100px'}}
                            action={{ InputType: "ac", paramName: "itemCategory2", acMethod: "CategoryDetail", 
                            acDepCtrl: { dparam: '%dataList.valLCat' } }}
                        />
                        <FormInput formObject={formObject} headerKey="bomHeaderRow"
                            action={{ InputType: "ac", paramName: "bomName", acMethod: "TargetItemBomByCategory", 
                            acDepCtrl: { 'dparam': '%dataList.valLDT', 'tdcat1': '#itemCategory',  'tdcat2': '#itemCategory2'},
                            actionParam:{} }} className='uiInput uiSpacerH10' style={{width:'300px'}}/>
                        <FormButton formObject={formObject} headerKey="bomHeaderRow"
                            action={{ refreshMode:"self", actionId: "refresh",  actionParam: {actionType: 'importBOMProcess'}, }}
                            className="uiActionButton uiSpacerH10" text={<SarasTrans value="Get BOM Process" />}></FormButton>
                    </UiRow>
                </FormWrapper>
                <div className="uiSpacer10"></div>
                <UiClear></UiClear>
                <UiViewHeading>
                    <UiTitle>
                        <span className="uiInline"><SarasTrans value = "BOM Process"/></span>
                    </UiTitle>
                    <UiAction>
                        <FormButton formObject={formObject} rowKey="" className="uiActionButton"
                            action={{ actionId: "new",  actionParam: {actionType : "addProcess"}, containerKey: "row" }}
                            text={<SarasTrans value="Add Record" />}>
                        </FormButton>
                    </UiAction>
                </UiViewHeading>
                <UiViewContent>
                    <ul className="uiListTable">
                        <li className="uiSearchHeading">
                            <ul>
                                <li className="uiColumnCenter uiColumn50"><SarasTrans value="Seq. No" /></li>
                                <li className="uiColumnCenter uiColumn150"><SarasTrans value="Process" /></li>
                                <li className="uiColumnCenter uiColumn90"><SarasTrans value="Est. Time" /></li>
                                <li className="uiColumnCenter uiColumn90"><SarasTrans value="Lab. Cost" /></li>
                                <li className="uiColumnCenter uiColumn90"><SarasTrans value="OH Cost" /></li>
                                <li className="uiColumnCenter uiColumn200"><SarasTrans value="Comment" /></li>
                                <li className="uiColumnCenter uiColumn50"><SarasTrans value="Action" /></li>
                            </ul>
                        </li>
                        {
                            Object.values(viewData ? viewData : {}).map((row, index) => (
                                <li><BomProcessAddRow formObject={formObject} rowKey={row.rowKey} viewData={row} key={index} index={index + 1}/></li>
                            ))
                        }
                    </ul>
                </UiViewContent>
            </UiView>            
        </FormDialog>
        </>
    )
}

export default withView(BomProcessAdd, "bomProcessAdd", "bomProcessAdd,bomProcess,bomHeader");